import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RNButton } from '@/components';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

interface Props {
  tableData: (string | number)[][];
}

export const RecurringCharges: React.FC<Props> = ({ tableData }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <View>
      {isOpen && (
        <View style={styles.table}>
          {tableData.map((row, idx) => (
            <View key={idx} style={styles.row}>
              <Text style={[styles.cell, styles.cellPrimary]}>{row[0]}</Text>
              <Text style={[styles.cell, styles.cellPrimary]}>{row[1]}</Text>
              <Text style={[styles.cell, styles.cellSecondary]}>{row[2]}</Text>
            </View>
          ))}
        </View>
      )}
      <RNButton
        title={isOpen ? 'Hide Recurring Charges' : 'Show Recurring Charges'}
        variant="link"
        onPress={() => setIsOpen((s) => !s)}
        style={styles.toggleBtn}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  table: {
    paddingTop: 16,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 6,
  },
  cell: {
    flex: 1,
    fontSize: 12,
  },
  cellPrimary: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  cellSecondary: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
  },
  toggleBtn: {
    alignSelf: 'flex-start',
    paddingTop: 16,
  },
});


